<template>
  <div class="container">
    <el-button type="text" size="mini" :disabled="task.status === 1" @click="viewProcess"
      >查看进度
    </el-button>
    <el-dialog title="构建进度" :visible.sync="detaiDialog" width="300" :append-to-body="true">
      <el-button type="text" @click="viewProcess">同步进度</el-button>
      &nbsp;&nbsp;
      <el-tag type="success" v-if="state === 0">运行中...</el-tag>
      <el-tag type="danger" v-else>长时间未响应</el-tag>
      <el-form ref="form" label-width="100px" v-loading="loading">
        <el-form-item label="构建xml进度">
          <el-progress
            style="line-height: 40px"
            :stroke-width="10"
            :percentage="progressObj.xml"
          ></el-progress>
        </el-form-item>
        <el-form-item label="生成zip进度">
          <el-progress
            style="line-height: 40px;"
            :stroke-width="10"
            :percentage="progressObj.zip"
          ></el-progress>
        </el-form-item>
        <el-form-item label="上传进度">
          <el-progress
            style="line-height: 40px"
            :stroke-width="10"
            :percentage="progressObj.upload"
          ></el-progress>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {apiGetZipTaskProgress} from '@/api';

export default {
  name: "",
  components: {},
  data() {
    return {
      detaiDialog: false,
      loading: false,
      state: 0,
      progressObj: {
        xml: 0,
        upload: 0,
        zip: 0
      }
    };
  },
  props: {
    task: {
      type: Object
    }
  },
  mounted() {},
  methods: {
    // getProcess () {
    //   this.viewProcess();
    //   if (!this.loading && this.detaiDialog) {
    //     setTimeout(() => {
    //       this.getProcess();
    //     }, 2000);
    //   }
    // },
    async viewProcess () {
      this.detaiDialog = true;
      try {
        const res = await apiGetZipTaskProgress(this.task.task_id);
        console.log(res);
        this.loading = true;
        this.progressObj.xml = Math.ceil(res.xml * 100) || 0;
        this.progressObj.upload = Math.ceil(res.upload * 100) || 0;
        this.progressObj.zip = Math.ceil(res.zip * 100) || 0;
        this.loading = false;
        this.state = res.state;
      } catch (e) {
        console.log(e);
        this.loading = true;
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    detaiDialog (val) {
      if (!val) {
        this.$emit('refresh');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    padding-right: 10px;
  }
</style>
